'use strict';
import { pdpOfferTimer } from '../../offertimer';
var util = require('../../util'),
	dialog = require('../../dialog'),
	tooltip = require('./tooltip'),
	bornModules = require('../../helpers/born.modules').default;

/**
 * Renders error in BISN form
 * @param emailInput jQuery-object of verified field
 * @param text error message
 */
function showError(emailInput, text) {
	var id = emailInput.attr('id') + '-error';
	if ($('#' + id).length) {
		$('#' + id).html(text).show();
	} else {
		$('<span></span>', {
			'id': id,
			'class': 'error'
		}).html(text).insertAfter(emailInput);
	}
}

/**
 * Adds event handler on form submit 
 */
function initEvents() {
	notifyPopupEvents();
}

function notifyPopupEvents() {
	var $pdpMain = $('.pdp');

	$pdpMain.off('click', '#backin-stock-product').on('click', '#backin-stock-product', function (e) {
		e.preventDefault();

		// If no variant selected - show tooltip
		if (!isVariantSelected.call(this)) {
			var $jsVariationSelect = $(this).closest('.pdpForm').find('.js-variation-select');
			tooltip.show($jsVariationSelect, Resources.BACKINSTOCK_TOOLTIP);
			return;
		}
		var $variantSelector = $(this).closest('.pdpForm').find('.size-conversion-container .sizeConversion .sizeLabel, .size-conversion-container .sizeConversion.no-conversion');
		let isNoConversion = $('.pdpForm').find('.size-conversion-container .sizeConversion.no-conversion').length > 0;
		if (!_isVariantSelectedSizeGrid.call(this)) {
			tooltip.show(isNoConversion ? $('.sizeDescription .sizeContainer') : $variantSelector, Resources.BACKINSTOCK_TOOLTIP);
			return;
		} else {
			tooltip.hide($variantSelector);
		}
		
		var source = $(this).data('source');

		if (source && source === 'quickview') {
			showBackInStockSection.call(this);
		} else {
			openBackInStockPopup.call(this);
		}
	});

	$pdpMain.off('change', '.product-detail .variation-select').on('change', '.product-detail .variation-select', function () {
		tooltip.hide($(this));
	});
}

function showBackInStockSection() {
	var $pdpForm = $(this).closest('.pdpForm'),
		$bisnForm = $pdpForm.find('.js-backinstock-form');

	// If already shown
	if ($bisnForm && $bisnForm.length >= 1) {
		return;
	}

	$.ajax({
		url: Urls.getBackInStockForm,
		data: $pdpForm.serialize(),
		success: function (response) {
			$pdpForm.append(response);
			$pdpForm.data('source', $('#source').val());
			initPopupFormEvents();
		}
	});
}

function openBackInStockPopup() {
	var $token = $(this).parent().find('.js-csrf-token'),
		$pid = $(this).parents().find('.js-pid');
		
	var notifyUrl = util.appendParamsToUrl(Urls.backInStockPopup, {
		'csrf_token': $token.val(),
		'pid': $pid.val(),
		'source': 'backinstock'
	});

	dialog.open({
		url: notifyUrl,
		options: {
			width: 400,
			update: true
		},
		afterCreateCallback: openNotifyPopupCallback
	});
}

function initPopupFormEvents() {
	scrollToEmail();
	// Notify me button on popup
	$('.js-notify-button').click(function (e) {
		e.preventDefault();
		var $fieldset = $(this).closest('.js-backinstock-form');
		var $emailInput = $fieldset.find('[name$=email]');
		var data = $fieldset.serialize();
		var btn = $fieldset.find("button[type=submit]");
		$.ajax({
			url: Urls.backInStock,
			method: 'POST',
			data: data + '&' + btn.attr('name'),
			dataType: 'json',
			success: function (data) {
				if (!data.validationError) {
					// Remove errors if any
					$emailInput.parent().find('span.error').remove();

					// Show confirmation
					$fieldset.html(data.message);

					var $source = $('.js-open-notifypopup').closest('.pdpForm').data('source');

					if ($source === 'cart') {
						$fieldset.find('.js-backinstock-continue').remove();
					}

				} else {
					showError($emailInput, data.message);
				}

			},
			error: function () {
				showError($emailInput, 'error');
			}
		});
	});

	// Continue shopping button handler
	$('.js-backinstock-form').on('click', '.js-backinstock-continue', function (e) {
		e.preventDefault();
		dialog.close();
	});
}

/**
 * Checks variant selector
 * 
 * @returns {Boolean} Returns true in case if variant was selected
 */
function isVariantSelected() {
	var $jsVariationSelect = $(this).closest('.pdpForm').find('.js-variation-select').find('select#va-size');

	if (!$jsVariationSelect.length) {
		return true;
	}

	return $jsVariationSelect && $jsVariationSelect.val().length > 0 && $jsVariationSelect.val().includes("size");
}

function _isVariantSelectedSizeGrid() {
	var $jsVariationSelect = $(this).closest('.pdpForm').find(
			'.size-conversion-container');
	if ($jsVariationSelect.length <= 0) {
		return true;
	}
	$jsVariationSelect = $jsVariationSelect
			.find('.sizeDescription .content-items .links-item.selected')

	if ($jsVariationSelect.length > 0) {
		return true;
	} else {
		return false;
	}
}

function scrollToEmail() {
		setTimeout(function () {
			var $emailField = $('.js-backinstock-form').find('input[name$="_email"]');
			$('.window-overlay').animate({
				scrollTop: $emailField.offset().top
			}, 500);

			$('.js-backinstock-form').find('input[name$="_email"]').on('focus', function(){
				var _this = $(this);
				setTimeout(function() {
					$('.overlay--active').scrollTop( $('.window-overlay--modal').height() );
				}, 500);
			});
		}, 500);
}

/**
 * Callback which is triggered on popup init event
 */
function openNotifyPopupCallback() {
	bornModules.carousel.init();
	bornModules.video.init();
	bornModules.selectTags.init();
	bornModules.qtyControl.init();
	bornModules.modalToggle.init();
	bornModules.toggle.init();
	initPopupFormEvents();
	pdpOfferTimer();
	$(window).trigger('modal-open');
}

module.exports.init = initEvents;



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/product/backinstock.js